import { QuotesDashboardPage, TssDashboardPage } from 'reports/pages';
import { quotesDashboardPath, tssDashboardPath } from 'reports/routes/routePaths';
import { Route } from 'router/types';

export const quotesDashboard: Route = {
  element: <QuotesDashboardPage />,
  exact: true,
  isPrivate: true,
  path: quotesDashboardPath(),
};

export const tssDashboard: Route = {
  element: <TssDashboardPage />,
  exact: true,
  isPrivate: true,
  path: tssDashboardPath(),
};

export const reports = [quotesDashboard, tssDashboard];
